import React from 'react';
import { SiArduino } from 'react-icons/si';

/**
 * ArduinoIcon
 * Ikona Arduino pre sekcie riadenia hardvéru.
 */
const ArduinoIcon = ({ className = 'inline-block align-middle', ...props }) => (
  <SiArduino className={className} {...props} />
);

export default ArduinoIcon;

